import request from '@/axios'

// 企微扫码登陆
export function wxLogin(data) {
  return request({
    url: process.env.VUE_APP_BASE_WEIXIN + '/thirdpart/enterprise_wechat/getStaff',
    method: 'post',
    data
  })
}

// 获取页面授权config
export function get_corp_signature(data) {
  return request({
    url: process.env.VUE_APP_BASE_WEIXIN + '/jssdk/js_sustain/get_corp_signature',
    method: 'post',
    data
  })
}

// 获取页面授权config
export function getMediaToQiniu(data) {
  return request({
    url: process.env.VUE_APP_BASE_WEIXIN + '/media/media/getMediaToQiniu',
    method: 'post',
    data
  })
}

// 获取页面授权config
export function get_agent_signature(data) {
  return request({
    url: process.env.VUE_APP_BASE_WEIXIN + '/jssdk/js_sustain/get_agent_signature',
    method: 'post',
    data
  })
}

// 获取页面授权config
export function deliveryWxLogin(data) {
  return request({
    url: process.env.VUE_APP_BASE_WEIXIN + '/thirdpart/enterprise_wechat/wxLogin',
    method: 'post',
    data
  })
}
